export default __webpack_public_path__ + "static/media/ball.4e98f23f.png";